// src/features/scope_module/components/Workspace.js
import React from 'react';
import { useDrop } from 'react-dnd';
import CanvasContainer from './CanvasContainer';
import Toolbar from './Toolbar';
import StatusBar from './StatusBar';

const ItemTypes = {
    FEATURE: 'feature',
};

const Workspace = () => {
    const [, drop] = useDrop(() => ({
        accept: ItemTypes.FEATURE,
        drop: (item, monitor) => {
            return undefined;
        },
    }));

  return (
    <div ref={drop} className="workspace">
      <Toolbar />
      <StatusBar />
      <div className="canvas-row">
        <CanvasContainer />
      </div>
    </div>
  );
};

export default Workspace;